var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDelegacia = function SvgDelegacia(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#ECF0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.925 56.94C41.925 56.94 41.0273 57.5 40 57.5C38.9727 57.5 38.1065 56.9505 38.1065 56.9505C35.3503 55.1339 33.2584 53.0746 31.8307 51.6692C31.6231 51.4648 31.4295 51.2742 31.25 51.1003C28.6285 48.5557 26 43.9428 26 40V31.2605C26 31.2605 26 30.3138 26.5652 29.4528C26.9086 28.9094 27.3773 28.4563 27.932 28.1315L38.432 22.8675C38.9535 22.6225 39.4768 22.5 40 22.5C40.5436 22.5051 41.0792 22.6313 41.568 22.8692L52.068 28.1315C52.6637 28.4224 53.1608 28.8818 53.4977 29.4528C54.0455 30.347 54 31.264 54 31.264V40C54 43.9007 51.3172 48.5628 48.7447 51.1003C48.5901 51.2526 48.4251 51.417 48.2498 51.5917C46.8246 53.0122 44.7175 55.1121 41.925 56.94ZM41.3238 32.1026C41.1145 31.5342 40.6742 31.25 40.0022 31.25C39.3302 31.25 38.8731 31.5321 38.6344 32.0956L37.6572 35.2281H34.2419C33.5664 35.275 33.1646 35.5823 33.0365 36.15C32.9077 36.7184 33.1198 37.2455 33.6707 37.732L36.1963 39.671L35.1113 43.4734C34.9503 44.0607 35.091 44.548 35.5334 44.9344C35.9758 45.3215 36.5526 45.3523 37.2638 45.0282L40.0022 43.122L42.6664 44.9876C43.2845 45.3495 43.8522 45.332 44.3681 44.9344C44.884 44.5375 45.0345 44.0348 44.8196 43.4272L43.7269 39.671L46.3337 37.732C46.893 37.242 47.1002 36.7149 46.9553 36.15C46.8104 35.5851 46.3974 35.2771 45.7184 35.2281H42.2807L41.3238 32.1026Z",
    fill: "#003A79"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelegacia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delegacia.8c4f295e.svg";
export { ForwardRef as ReactComponent };